import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "История. 6 класс",
        subject: "Формирование умения устанавливать причинно-следственные связи событий на примере темы «Политическая раздробленность» при обучении истории в 6 классе",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Формирование умения устанавливать причинно-следственные связи событий на примере темы «Политическая раздробленность» при обучении истории в 6 классе",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Синельников Игорь Юрьевич",
                grade: "кандидат педагогических наук, старший научный сотрудник лаборатории социально-гуманитарного общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p style="font-weight: bold; padding-bottom: 1rem; padding-top: 1rem;">Вопрос 1. Почему данная тема – сложная?</p>
                                <p>Тема раздробленности на Руси сложна, прежде всего, с точки зрения обилия причин, которые привели к распаду древнерусского государства, просуществовавшего фактически 250 лет – с 882 по 1132 год – со времён князя Олега вплоть до смерти князя Мстислава. Распад государства, долгое время называвшегося в отечественной науке «Киевская Русь», на ряд самостоятельных земель-княжеств был обусловлен многими причинами – политическими, экономическими, культурными.  </p>
                                <p>Однако их представление во всей полноте и сложности в школе, а особенно – в 6-м классе, когда систематическое изучение истории, по сути, только начинается, – очень затруднено и практически невозможно. Обилие и сложность причин раздробленности, – даже при «упрощённом» подходе, который используется в школьных учебниках, – всё равно представляет серьёзные трудности для понимания и усвоения школьниками. </p>
                                <p>А значит, педагог должен найти максимально простой и доступный для шестиклассников способ объяснения причинно-следственных связей столь сложного исторического явления как распад древнерусского государства. </p>
                                <p style="font-weight: bold; padding-bottom: 1rem; padding-top: 1rem;">Вопрос 2. В чём заключается помощь учителю в раскрытии данной темы?</p>
                                <p>Помочь учителю в организации работы над вопросом о причинах раздробленности можно следующим способом – показать довольно простой, но методически эффективный алгоритм использования текста учебника для объяснения причин политической раздробленности средневековой Руси. </p>
                                <p>Именно выделение основных этапов работы с текстом учебника и приёмов фиксации, формируемых у обучающихся знаний и умений, окажет действенную помощь учителю в работе над темой раздробленности и проблемой усвоения школьниками причин, которые обусловили распад единого русского государства в начале 12 века.</p>
                                <p style="font-weight: bold; padding-bottom: 1rem; padding-top: 1rem;">Вопрос 3. На какие вопросы получит ответы учитель при работе с данным кейсом?</p>
                                <p>При работе с кейсом учитель получит ответы на следующие вопросы:</p>
                                <p>
                                <ul>
                                <li>как грамотно организовать работу шестиклассников с текстом учебника?</li>
                                <li>как помочь обучающимся в развитии умений находить в тексте необходимую информацию и фиксировать получаемые из текста знания в виде краткого письменного ответа?</li>
                                <li>как сформировать у школьников умение использовать схемы для наглядного отображения причинно-следственных связей?</li>
</ul>
</p>
                                
                                </div>
                                `
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `
                <p>Любому учителю-предметнику должно быть хорошо известно о том, что формирование у обучающихся умения чётко определять причины и следствия событий и процессов – это одна из насущных задач современного российского образования. В стандарте основной школы эта задача обозначается как метапредметная. Это означает, что на её решение должны быть направлены усилия всех учебных предметов без исключения!</p>
                <p>Как показывает анализ результатов Всероссийских Проверочных Работ по истории, задания, в которых требуется установить причины и следствия исторических событий, вызывают у шестиклассников серьёзные проблемы. Об этом пишут в своих аналитических справках многие учителя. Значит, проблема есть и её нужно решать!</p>
                <p>Итак, что должен знать учитель истории для успешного решения существующей проблемы?</p>
                <p>Прежде всего, ему нужно понять, что на решение этой проблемы его нацеливают не только низкие результаты ВПР.</p>
                <p>Гораздо важнее для педагога понимание того, что научить школьников объяснению причин и следствий важнейших исторических событий, причём – используя для этого материалы учебника, – эта задача стратегическая! </p>
                <p>И поставлена она перед учителем вполне конкретно – в Федеральной рабочей программе по истории для пятых-девятых классов.</p>
                <p>Помнить об этом необходимо.</p>
                <p>Но важно, чтобы каждый учитель помнил и то, что без чёткого разъяснения школьникам причин произошедшего невозможно будет добиться от них понимания того, почему именно в начале 12-го века «государство Русь распалось на ряд фактически самостоятельных государственных образований» и «наступил период политической раздробленности». А ведь это – установленный наукой факт!</p>
                <p>И ещё об одном установленном наукой факте должен помнить учитель. Этот факт состоит в том, что изучая причину как «внутреннюю связь между тем, что уже есть, и тем, что ещё порождается, что ещё только становится», – педагог должен понимать сам и уметь объяснить ученикам одну простую и при этом – очень сложную вещь! А именно – в каждом конкретном случае человек должен отчётливо понимать последовательность явлений. То есть то, что к определённому следствию привели именно эти, а не какие-то другие причины.</p>
                <p>Так что же делать учителю на практике? Об этом вы узнаете в видеоматериале.</p>
                
                `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Алексашкина Л.Н. Преподавание истории в школе: от педагогического проекта к практике. Пособие для учителя. – Москва: ООО «Русское слово – учебник», 2018",
                "Сборник метапредметных заданий: история, обществознание, география: 5–9 кл. / Э. М. Амбарцумова, Е. А. Гевуркова, С. Е. Дюкова, Т. В. Коваль, А. Ю. Лазебникова, Т. Е. Лискова, М. Ю. Романова, И. Ю. Синельников, О. А. Французова / Сост. и ред. А. Ю. Лазебникова, И. Ю. Синельников. – Москва: «Экзамен», 2018. - М.: ФГБНУ «Институт стратегии развития образования РАО». - 191, [1] с.",
                "Синельников И.Ю. Специфика метапредметных заданий и их использование на уроках истории, обществознания и географии // Преподавание истории и обществознания в школе. 2018, № 6"
            ],
            historical: [],
            sites: [],
            filesToDownload: [
                {
                    link: "./files/additional.pdf",
                    fileName: "Раздаточные материалы для организации работы обучающихся на уроке"
                }
            ]
        }
    ],
};
